import React from "react";

type BlockIconProps = {
  color?: string;
};

const BlockIcon = (props: BlockIconProps) => {
  const { color } = props;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.3334 1.66675L11.0001 11.0001M11.0001 11.0001L1.66675 20.3334M11.0001 11.0001L1.66675 1.66675M11.0001 11.0001L20.3334 20.3334"
        stroke={color || "#D63F49"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BlockIcon;
